import React, { PureComponent } from 'react'
import Survey from 'app/Components/Survey'
import Form from './questions/form'
import backgroundImg from './form-bg.jpg'

export default class FormPage extends PureComponent {
  render() {
    return (
      <div>
        <Survey firstPanel={Form} backgroundImg={backgroundImg}/>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./form/index.js
 **/